import React from 'react'

import stuffList from '../data/stuff.json'

import Slider from 'react-slick'

import './styles/OurTeam.scss'

function OurTeam() {
    let settings = {
        slidesToShow: 5,
        slidesToScroll: 1,
        // autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',


        responsive: [
            {
                breakpoint: '900px',
                settings: {slidesToShow: 3, autoplay: true},
            },
        ],
    }

    return (
        <div className="team-container" id={'our-team'}>
            <div>
                <h2 className="align-center">Наша команда</h2>
                <p className="main-text" style={{textAlign: 'center'}}>Кибернетика - крупная (50+ человек), амбициозная, специализирующаяся на корпоративных заказчиках,
                    команда профессионалов.</p>
            </div>
            {/*<Slider {...settings}>*/}
            {/*    {stuffList.map((el, index) => {*/}
            {/*        return (*/}
            {/*            <div id="our-team" key={`our-team-${index}`}>*/}
            {/*                <div className="team-container__person">*/}
            {/*                    <img src={require(`../images/stuff/${el.id}.png`)} alt="photo" className="team-container__photo" />*/}
            {/*                    <div className="main-text main-text--bold align-center">{el.name}</div>*/}
            {/*                    <div className="main-text main-text--thin main-text--sm align-center">{el.position}</div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        )*/}
            {/*    })}*/}
            {/*</Slider>*/}

            <div className={'team-container__grid'}>
                {stuffList.map((el, index) => {

                    if (index <= 1) {
                        let imageUrl = require(`../images/stuff/${el.id}.png`)
                        let imageSmile = require(`../images/stuff/${el.id}--smile.jpg`)
                        return (
                            <div key={index} className={'team-container__person'}>
                                <div className="team-container__photo">
                                    <div style={{backgroundImage: `url(${imageSmile})`}} alt="photo"
                                         className="team-container__photo-inner team-container__photo-inner--smile"/>
                                    <div style={{backgroundImage: `url(${imageUrl})`}} alt="photo"
                                         className="team-container__photo-inner team-container__photo-inner--not-smile"/>
                                </div>

                                <div>{el.name}</div>
                                <div
                                    className="main-text main-text--thin main-text--sm align-center">{el.position}</div>
                            </div>
                        )

                    } else {
                        return
                    }
                })}
            </div>
            <div className={'team-container__grid'}>
                {stuffList.map((el, index) => {
                    // console.log('123')
                    if (index <= 1) {
                        return
                    }
                    let imageUrl = require(`../images/stuff/${el.id}.png`)
                    let imageSmile = require(`../images/stuff/${el.id}--smile.jpg`)


                    return (
                        <div key={index} className={'team-container__person'}>
                            <div className="team-container__photo">
                                <div style={{backgroundImage: `url(${imageSmile})`}} alt="photo"
                                     className="team-container__photo-inner team-container__photo-inner--smile"/>
                                <div style={{backgroundImage: `url(${imageUrl})`}} alt="photo"
                                     className="team-container__photo-inner team-container__photo-inner--not-smile"/>
                            </div>

                            <div>{el.name}</div>
                            <div
                                className="main-text main-text--thin main-text--sm align-center">{el.position}</div>
                        </div>
                    )


                })}
            </div>
        </div>
    )
}

export default OurTeam
